export const options = [
  {
    id: 'industrial-printing-landing',
    type: 'video',
    bgImage: 'https://www.hp.com/content/dam/sites/worldwide/industrial-printers/indigo-digital-presses/printosx-software-service-solutions/Background-image.jpg',
    message: 'PrintOS',
    message2: "start.Landing_WelcomeMessage",
    video: {
      id: 'iNDtJL74qGM',
    },
  },
  {
    type: 'info-static-column',
    theme: 'dark2',
    bg: 'linear-gradient(90deg, rgba(151, 56, 134, 1) 30%, rgba(0, 150, 214, 1))',
    watermarks: [
      {
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg',
        iconSize: '240',
        top: 0,
        left: '-40px',
        iconColor: '#fff',
      },
      {
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg',
        iconSize: '160',
        top: '160px',
        left: '680px',
        iconColor: '#fff',
      },
      {
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg',
        iconSize: '220',
        top: '-20px',
        left: '930px',
        iconColor: '#fff',
      },
    ],
    options: [
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg',
        iconSize: '220',
        // iconColor: '#fff',
        iconOutline: true,
        overlay: 'orgCount',
        title: 'start.Landing_Category1',
        message: 'start.Landing_Details1'
      },
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg',
        iconSize: '220',
        // iconColor: '#fff',
        iconOutline: true,
        overlay: 'userCount',
        title: 'start.Landing_Category2',
        message: 'start.Landing_Details2'
      },
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg',
        iconSize: '220',
        // iconColor: '#fff',
        iconOutline: true,
        overlay: 'deviceCount',
        title: 'start.Landing_Category3',
        message: 'start.Landing_Details3'
      },
    ],
  },
  {
    type: 'info-static-column',
    theme: 'light1',
    message: 'start.SignIn_WhatDoesPrintOSDo',
    align: 'center',
    options: [
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/Optimize.svg',
        iconSize: '120',
        iconColor: '#973886',
        title: 'start.Pillar_Optimize',
        message: 'start.Pillar_Optimize_Highlight',
        content: 'start.Pillar_Optimize_Details'
      },
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/Automate.svg',
        iconSize: '120',
        iconColor: '#4b67ae',
        title: 'start.Pillar_Automate',
        message: 'start.Pillar_Automate_Highlight',
        content: 'start.Pillar_Automate_Details'
      },
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/Grow.svg',
        iconSize: '120',
        iconColor: '#0096d6',
        title: 'start.Pillar_Grow',
        message: 'start.Pillar_Grow_Highlight',
        content: 'start.Pillar_Grow_Details'
      },
    ],
  },
  {
    type: 'transition-small',
    message: 'start.Pillar_Optimize_Section',
    messageIcon: {
      url: 'https://cdn.printos.com/images/signin/landing/Optimize.svg',
      color: 'white',
      size: '48',
    },
  },
  {
    type: 'carousel',
    panelIndex: 0,
    transition: '.5s',
    panels: [
      {
        id: 'print-beat-app',
        panelImage: 'https://cdn.printos.com/images/market/products/summary/print-beat/lf-printbeat-report-blog.png',
        // contentOnRight: true,
        iconUrl: 'https://cdn.printos.com/images/application/icons/printbeat.svg',
        iconSize: '48',
        iconColor: 'white',
        title: 'app.printbeat_Name',
        // message: '',
        content: "start.PrintBeat_Desc",
        bullets: [
          "start.PrintBeat_Bullet1",
          "start.PrintBeat_Bullet2",
          "start.PrintBeat_Bullet3"
        ],
        video: {
          //id: '86BHQ1vGzyM',
          id: 'oqZshkSDV-Y',
        },
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        id: 'printos-mobile-app',
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/industrial-printers/indigo-digital-presses/printosx-software-service-solutions/Image7.jpg',
        // contentOnRight: true,
        title: 'start.PrintBeatMobile_Title',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/print-beat-mobile.svg',
        iconSize: '48',
        iconColor: 'white',
        content: 'start.PrintBeatMobile_Desc',
        video: {
          id: 'a3zlL8q9SZ0',
        },
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/large-formats/printos/Service%20center@2x.png',
        // contentOnRight: true,
        title: 'app.pwi-sc_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/pwi-sc.svg',
        iconSize: '48',
        iconColor: 'white',
        content: 'start.IndigoSC_Desc',
        video: {
          id: '4cg4_K8tCKo',
        },
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/large-formats/printos/LF_PrintOS-Media_locator-290x290%20-%20Luis%20Medina.png',
        // contentOnRight: true,
        title: 'app.ml_Name',
        iconUrl: 'https://cdn.printos.com/images/application/icons/ml.svg',
        iconSize: '48',
        iconColor: 'white',
        video: {
          id: 'P1FpauyAPmc',
        },
        // message: '',
        content: 'start.MediaLocator_Desc',
        link: {
          title: 'start.Link_GoNow',
          url: 'https://www.printos.com/ml/#/medialocator',
        },
      },
    ],
  },
  // {
  //   type: 'transition-small',
  //   message: 'start.Pillar_Automate_Section',
  //   messageIcon: {
  //     url: 'https://cdn.printos.com/images/signin/landing/Automate.svg',
  //     color: 'white',
  //     size: '48',
  //   },
  // },
  // {
  //   type: 'carousel',
  //   panelIndex: 0,
  //   transition: '.5s',
  //   panels: [
  //     // {
  //     //   panelImage: 'https://www.hpapplicationscenter.com/images/v4/landing_page/slide_images/2-desginer.jpg',
  //     //   // contentOnRight: true,
  //     //   title: 'app.wallart_Name',
  //     //   // message: '',
  //     //   iconUrl: 'https://cdn.printos.com/images/application/icons/wallart.svg',
  //     //   iconSize: '48',
  //     //   iconColor: 'white',
  //     //   video: {
  //     //     id: 'yr9JTT4YoDo'
  //     //   },
  //     //   content: 'app.wallart_Desc',
  //     //   link: {
  //     //     title: 'start.LearnMore',
  //     //     url: 'https://www.hpapplicationscenter.com/',
  //     //   },
  //     // },
  //   ],
  // },
];
